import { createMuiTheme } from '@material-ui/core'
import { esES } from '@material-ui/core/locale'

const theme = createMuiTheme(
  {
    palette: {
      primary: {
        main: '#8B5DBC',
      },
      common: {
        white: '#FFFFFF',
      },
      secondary: {
        main: '#F15B5B',
      },
      error: {
        main: '#E94E67',
      },
      warning: {
        main: '#FFB71B',
      },
      // text: {
      //   primary: `#4C4C4C`,
      //   secondary: `rgba(0, 0, 0, 0.54)`,
      //   disabled: `rgba(0, 0, 0, 0.38)`,
      // },
    },
    typography: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeightBold: 600,
      h5: {
        fontWeight: 600,
      },
    },
    shape: {
      borderRadius: 10,
    },
    spacing: 10,
    breakpoints: {
      values: {
        xxs: 0,
        xs: 300,
        sm: 600,
        md: 1024,
        lg: 1440,
        xl: 1920,
      },
    },
  },
  esES
)

export default theme
